/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CPPAndChatUnreadCount
 */
export interface CPPAndChatUnreadCount {
    /**
     * 
     * @type {string}
     * @memberof CPPAndChatUnreadCount
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof CPPAndChatUnreadCount
     */
    cpp_count?: number;
    /**
     * 
     * @type {number}
     * @memberof CPPAndChatUnreadCount
     */
    chat_count?: number;
    /**
     * 
     * @type {number}
     * @memberof CPPAndChatUnreadCount
     */
    count?: number;
}

/**
 * Check if a given object implements the CPPAndChatUnreadCount interface.
 */
export function instanceOfCPPAndChatUnreadCount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CPPAndChatUnreadCountFromJSON(json: any): CPPAndChatUnreadCount {
    return CPPAndChatUnreadCountFromJSONTyped(json, false);
}

export function CPPAndChatUnreadCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): CPPAndChatUnreadCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'cpp_count': !exists(json, 'cpp_count') ? undefined : json['cpp_count'],
        'chat_count': !exists(json, 'chat_count') ? undefined : json['chat_count'],
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function CPPAndChatUnreadCountToJSON(value?: CPPAndChatUnreadCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'cpp_count': value.cpp_count,
        'chat_count': value.chat_count,
        'count': value.count,
    };
}

